<div class="header-container">
  <div class="logo-container">
    <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
    <nb-icon [icon]="(materialTheme$ | async) ? 'bars' : 'bars'"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">ESS Portal</a>
  </div>
  <!-- <nb-select
    status="primary"
    matRipple
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
  >
    <nb-option
      *ngFor="let theme of themes"
      [value]="theme.value"
      matRipple
    >{{ theme.name }}</nb-option>
  </nb-select> -->
  <!-- <ngx-layout-direction-switcher class="direction-switcher"></ngx-layout-direction-switcher> -->
</div>

<div class="header-container">
  <!-- <nb-actions size="small"> -->
    <!--
        <nb-action class="control-item">
          <nb-search
            type="rotate-layout"
            matRipple
            [matRippleUnbounded]="true"
            [matRippleCentered]="true"
          ></nb-search></nb-action> -->
    <!-- <nb-action class="control-item"
               icon="email-outline"
               matRipple
               [matRippleUnbounded]="true"
               [matRippleCentered]="true"></nb-action>
    <nb-action class="control-item"
               icon="bell-outline"
               matRipple
               [matRippleUnbounded]="true"
               [matRippleCentered]="true"></nb-action>
    <nb-action class="user-action"
               *nbIsGranted="['view', 'user']"
               matRipple
               [matRippleUnbounded]="true"
               [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions> -->
  
  <div class="user-infor">
  Hi! {{(authService.userData | async)?.full_name}}
  </div>
  <div class="wrapper">
    <div class="dropdowns-wrapper">
      <div class="dropdown-container">
        <div class="notifications dropdown dd-trigger" (click)="toggle()">
          <span class="count animated" *ngIf="notificationService.data" id="notifications-count">{{notificationService.countUnread }}</span>
          <span class="fa fa-bell"></span>
        </div>
        <div class="dropdown-menu animated" style="text-align:center" *ngIf="notificationService.data" id="notification-dropdown" [ngStyle]="{'display': (isVisible) ? 'block' : 'none'}">
          <div class="dropdown-header">
            <span class="triangle"></span>
            <span class="heading">Notifications</span>
            <span class="count" id="dd-notifications-count">{{notificationService.countUnread }}</span>
          </div>
          <div class="dropdown-body">
            <div class="notification" *ngFor="let data of notificationService.data">
              <span class="heading" style="position:center;text-align:center"><b>{{data.title}}</b></span>
              <div class="notification-text" style="text-align:left">
                <span class="highlight" style="word-break: break-all !important;">{{data.message}}</span>
                <div *ngFor="let data of data.actions" class="row">
                  <a *ngIf="data.type == 'Link'" href="{{data.requestUri}}"> {{data.name}}</a>
                  <button type="button" (click)="executeAction(data)" *ngIf="data.type == 'Button'" class="btn btn-primary">
                    {{data.name}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-login" (click)="logout()">
    Logout
  </div>
</div>
